export class PreQuoteCompleteCommand {
    verificationId: string;
    isComplete: boolean;

    constructor(verificationId: string, isComplete: boolean) {
        this.verificationId = verificationId;
        this.isComplete = isComplete;
    }
}
